import { Loader } from '@googlemaps/js-api-loader';

const loader = new Loader({
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '',
    libraries: ['places'],
    language: 'nl',
    region: 'NL',
});

export const loadGoogleMaps = () => loader.importLibrary('maps');
